// extracted by mini-css-extract-plugin
module.exports = {"container":"ComicCard_container__1Yxju","title":"ComicCard_title__-DCHu","comic-num":"ComicCard_comic-num__29cAE","comic-img":"ComicCard_comic-img__2_U7Z"};